import { SearchParams } from '@/types'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const weatherLinkApi = {
  getWeatherStation() {
    const url = '/api/sensor/stations'
    return axiosClient.get(url)
  },
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/sensor/weatherlink/stations'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getSync() {
    const url = `/api/weather/sync-station-site-sensor`
    return axiosClient.get(url)
  },
}

export default weatherLinkApi
